module.exports = __webpack_public_path__ + "static/img/8.885c1c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/8.png
// module id = EYmZ
// module chunks = 1